var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ISelect',_vm._b({staticClass:"i-select",class:{ 'is-error': _vm.isError },attrs:{"initValue":_vm.initValue},on:{"menuClick":_vm.inputHandler}},'ISelect',_vm.props,false))}
var staticRenderFns = []

export { render, staticRenderFns }